import { safeWindowOpen } from '../../helpers/safeUrlOpen';

export const onDeepLinkClick = (url: string): void => {
  safeWindowOpen(url);
};
